module.exports = __webpack_public_path__ + "img/mont-desk.13a4fe41.png";